import React from "react";
import timeFunction from "../../functions/getTime";

/**
 * Activity card — design/"Mainpage - HCU 2026.png" (right column)
 *   420 x 203, photo washed out under a light grey veil, white text pinned to
 *   the bottom: day / month / time on the left, event title beside it.
 */
export default function DateCard(props) {
  const time = timeFunction.getActivityTime(
    props.lang,
    props.data.date.startDate
  );

  const imageUrl =
    props.data && props.data.image && props.data.image[0]
      ? `${process.env.REACT_APP_API_URL}${props.data.image[0].url}`
      : null;

  return (
    <div
      id="datecard"
      className={
        "group h-[203px] rounded-[12px] overflow-hidden flex flex-col justify-end px-[20px] pb-[18px] cursor-pointer " +
        (props.hasBg ? "" : "bg-white border-[1px] border-cardBorder")
      }
      onClick={() => {
        if (props.page === "newsAndActivity/activity")
          window.open(
            `/${props.lang}/${props.page}/${props.data.slug}`,
            "_self"
          );
      }}
      style={
        props.hasBg && imageUrl
          ? {
              background: `linear-gradient(rgba(170, 170, 170, 0.6), rgba(170, 170, 170, 0.6)), url(${imageUrl}) center / cover no-repeat, #D9D9D9`,
            }
          : undefined
      }
    >
      <div
        className={`flex gap-[25px] ${props.hasBg ? "text-white" : "text-slateGray"}`}
      >
        <div className="shrink-0">
          <h1 className="text-display font-bold leading-none">
            {time[0]}
          </h1>
          <h1 className="text-body font-medium leading-none mt-[15px]">
            {time[1]}
          </h1>
          <p className="text-small font-medium leading-none mt-[16px] whitespace-nowrap">
            {time[3]}
          </p>
        </div>

        {props.data && props.data.title && (
          <p className="flex-1 text-lead font-medium text-left leading-[1.3] line-clamp-2 group-hover:text-brand transition-colors duration-200">
            {props.lang === "th"
              ? props.data.title.event_TH
              : props.data.title.event_EN}
          </p>
        )}
      </div>
    </div>
  );
}
